import { bodyBgBase64 } from './BodyBgStore.js';

export const updateBodyBgBase64 = (value) => bodyBgBase64.update(oldValue => value);
